export const SCALE = {
  not_meet_expectactions: [0, 21],
  below_expectations: [22, 43],
  meet_expectations: [44, 65],
  exceeds_expectations: [66, 89],
  outstanding: [90, 100],
}
